import { ERROR_INVALID_CONFIG_PARAM } from '../../logger/constants';
import { DEBUG, OPTIMIZED, NONE } from '../constants';
import { stringToUpperCase } from '../lang';
export function validImpressionsMode(log, impressionsMode) {
    impressionsMode = stringToUpperCase(impressionsMode);
    if ([DEBUG, OPTIMIZED, NONE].indexOf(impressionsMode) > -1)
        return impressionsMode;
    log.error(ERROR_INVALID_CONFIG_PARAM, ['impressionsMode', [DEBUG, OPTIMIZED, NONE], OPTIMIZED]);
    return OPTIMIZED;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/utils/settingsValidation/impressionsMode.js
// module id = 3820
// module chunks = 25